import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WelcomePlannerViewService } from '../../services';

@Component({
  selector: 'app-all-ready',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './all-ready.component.html',
  styleUrls: ['./all-ready.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllReadyComponent{
  private _welcomePlannerViewService = inject(WelcomePlannerViewService);
  
  protected isAllReadyViewShown = this._welcomePlannerViewService.isAllReadyViewShown;
}
